export default ({ app: { router }, store }) => {
  router.beforeEach((to, _from, next) => {
    if (store.getters['client/updateRequired']) {
      location.assign(router.options.base.replace(/\/$/, '') + to.fullPath)
    } else {
      next()
    }
  })
}
